import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import { theme } from '../../theme'

export const Background = styled(motion.div)`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(201 201 201 / 0.68);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000000;
    pointer-events: visible;

`

export const ModalContent = styled(motion.div)`
position: relative;
    width: 71rem;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
    padding: 4rem 4rem 2rem 4rem;
    margin: 0 2rem;
    overflow-y: scroll;
    max-height: 100vh;
    
    ::-webkit-scrollbar {
        width: 4px;
    }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    // background: rgba(255, 255, 255, 0.4);
    background: grey;
    border-radius: 4px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`

export const ModalHeader = styled.div`
    font-weight: 700;
    font-size: 1.6rem;
    color: ${theme.colors.mainBlue};
    text-transform: capitalize;
`
export const ModalBody = styled.div`
    
`
export const ModalCancelBtn = styled.div`
cursor: pointer;
    position: absolute;
    top: 4rem;
    right: 4rem;
    width: 2.4rem;
    height: 2.4rem;

    svg {
        width: 100%;
    height: 100%;
    }
`